<template>
    <div class="modal fade" :id="id" role="dialog" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header bg-secondary text-white">
                    <h6 class="modal-title"><i class="far fa-code-merge fa-fw me-2"></i>Unisci selezionati</h6>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <p class="text-muted small mb-2">Scegli in quale record unire i selezionati: gli altri verranno eliminati.</p>
                    <div class="form-check mb-1" v-for="item in items" :key="item[idField]">
                        <input class="form-check-input" type="radio" :id="id + '_' + item[idField]" :value="item[idField]" v-model="idTarget">
                        <label class="form-check-label" :for="id + '_' + item[idField]">
                            <span class="text-muted me-1">#{{ item[idField] }}</span>{{ label(item) }}
                        </label>
                    </div>
                    <div class="form-check border-top pt-2 mt-2" v-if="nuova">
                        <input class="form-check-input" type="radio" :id="id + '_nuova'" :value="0" v-model="idTarget">
                        <label class="form-check-label fw-semibold" :for="id + '_nuova'">Nuova: crea un nuovo record e unisci tutti i {{ items.length }} selezionati</label>
                    </div>
                </div>
                <div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">ANNULLA</button>
                    <button type="button" class="btn btn-success btn-sm" @click.prevent="unisci()"><i class="far fa-code-merge fa-fw me-1"></i>Unisci</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PopUpMerge',
    props: {
        id: { type: String, default: 'popUpMerge' },
        api: { type: String, required: true },
        idField: { type: String, required: true },
        label: { type: Function, required: true },
        // true = mostra l'opzione "Nuova": su @nuova il padre apre la sua scheda di creazione e chiama attendi(idModal),
        // poi creato(id) al salvataggio
        nuova: { type: Boolean, default: false }
    },
    emits: ['merged', 'nuova'],
    data() {
        return { filters: global.filters, items: [], idTarget: 0, inAttesa: false }
    },
    methods: {
        open(items) {
            if (items.length < 2) { utils.alert.warning('Seleziona almeno due elementi da unire.'); return; }
            this.items = items;
            this.idTarget = items[0][this.idField];
            this.inAttesa = false;
            this.filters.openPopUp(this.id);
        },
        unisci() {
            if (this.idTarget == 0) {
                this.filters.closePopUp(this.id);
                this.$emit('nuova');
                return;
            }
            this.esegui(this.idTarget, '"' + this.label(utils.array.select(this.items, this.idField, this.idTarget, 1)[0]) + '"');
        },
        // in attesa finché la scheda di creazione resta aperta: chiusa senza salvare = annullato
        attendi(idModal) {
            this.inAttesa = true;
            document.getElementById(idModal).addEventListener('hidden.bs.modal', () => { this.inAttesa = false; }, { once: true });
        },
        // la scheda emette a ogni salvataggio: si agisce solo sul primo dopo "Nuova"
        creato(idNuovo) {
            if (!this.inAttesa || !(idNuovo > 0)) return;
            this.inAttesa = false;
            this.esegui(idNuovo, 'il nuovo record #' + idNuovo);
        },
        esegui(idTarget, descrizione) {
            var ids = this.items.map(i => i[this.idField]);
            utils.alert.confirm('Unire ' + ids.filter(i => i != idTarget).length + ' elementi in ' + descrizione + '? L\'operazione non si annulla.', () => {
                utils.put(this.api, { ID_TARGET: idTarget, IDS: ids }, (r) => {
                    if (r.esito == 0) {
                        this.filters.closePopUp(this.id);
                        utils.alert.success(r.messaggio);
                        this.$emit('merged');
                    }
                });
            }, this.$root);
        }
    }
}
</script>
